/* global axios */
import ApiClient from '../ApiClient';

// Teletel-owned SLA endpoints beyond policy CRUD (policy CRUD reuses the
// stock SlaAPI client repointed at /teletel). Every endpoint here is
// fail-closed server-side (403, code TELETEL_SLA_DISABLED) while
// TELETEL_SLA_ENABLED is not explicitly true.
class TeletelSlaAPI extends ApiClient {
  constructor() {
    super('teletel/sla_inbox_assignments', { accountScoped: true });
  }

  getAssignments() {
    return axios.get(this.url);
  }

  updateAssignments(assignments) {
    return axios.patch(this.url, { assignments });
  }

  getReport(params = {}) {
    return axios.get(`${this.baseUrl()}/teletel/sla_reports`, { params });
  }

  downloadReport(params = {}) {
    return axios.get(`${this.baseUrl()}/teletel/sla_reports.csv`, {
      params,
      responseType: 'blob',
    });
  }

  assignConversation(conversationId, slaPolicyId) {
    return axios.post(`${this.baseUrl()}/teletel/sla_assignments`, {
      conversation_id: conversationId,
      sla_policy_id: slaPolicyId,
    });
  }
}

export default new TeletelSlaAPI();
